import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    loaded: construction.parameters_loaded,
    available: construction.available?.pressing || [],
    info: construction.info?.pressing || null,
    selected: construction.selected?.pressing ?? null,
    walls_color_selected: construction.selected?.walls_color ?? null,
    colorsAvailableColors: construction.colorsPressings?.colors || {}
  })
);
